import { __awaiter, __generator } from "tslib";
export var registerQualified = function (analytics) {
    if (!window.qualified || typeof window.qualified !== 'function') {
        return;
    }
    window.qualified('handleEvents', function (eventName, eventData) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var email;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        email = (_a = eventData === null || eventData === void 0 ? void 0 : eventData.field_values) === null || _a === void 0 ? void 0 : _a.email;
                        if (!email) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, analytics.identify(null, { email: email })];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, analytics.track(eventName)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    });
};
//# sourceMappingURL=index.js.map